import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

export default class SmsProvider extends HttpRequest {
  constructor () {
    super(process.env.VUE_APP_API)
  }

  single (to, text) {
    this.setHeader(getAuthToken())
    return this.post('/sms/single', {
      from: 'CAMPBKK',
      to,
      text
    })
  }
}
